(function () {
  'use strict';

  angular.module('lif').directive('onErrorSrc', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        if (!attrs.ngSrc) {
          element.attr('src', attrs.onErrorSrc);
        } else {
          element.bind('error', function () {
            if (attrs.src !== attrs.onErrorSrc) {
              attrs.$set('src', attrs.onErrorSrc);
            }
          });
        }
      }
    };
  });
})();